import React from "react";
import logo from "../../Assets/Image/new.PNG";
import "./About.css";
import { Helmet } from "react-helmet";

export default function About() {
  return (
    <>
      <Helmet>
        <title>About</title>
      </Helmet>
      <div className="about  bg-body-tertiary">
        <div className="container py-5 w-75 ">
          <h1 className="heading text-uppercase mb-5">About Us</h1>
          <div className="mainText d-flex justify-content-between gap-5">
            <p className="fs-5 fw-400 w-50">
              <span className="fs-3 fw-700 main-color">Welcome to Vehex</span>,
              your trusted partner for quality auto parts and premium service.
              <br /> We are passionate about helping car enthusiasts and
              everyday drivers keep their vehicles running at their best and
              looking great.
              <p className="main-color fs-5 fw-500 p-0 m-0">
                With Vehex, your journey is our priority.
              </p>
              <p className="main-color  fs-5 fw-500 p-0 m-0">
                Join us to achieve excellence in the automotive world.
              </p>
            </p>
            <div class="image-column w-25">
              <img src={logo} alt=" Logo Img" className="w-100" height={150} />
            </div>
          </div>
          <div className="detailsUs w-100 my-5 ">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button p-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    <h4 className="fs-3 m-0 py-2 px-3 aboutHeading ab-1 position-relative">
                      Our message
                    </h4>
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse "
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body fs-5 p-2">
                    At Vehex, we strive to provide reliable, innovative and
                    competitively priced solutions to meet all your automotive
                    needs. We put quality and customer satisfaction at the
                    forefront of our priorities to ensure you receive the best
                    products and services.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed  p-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <h4 className="fs-3 m-0 py-2 px-3 aboutHeading ab-2 position-relative">
                      Why choose Vehex?
                    </h4>
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body p-2">
                    <ul className="fs-5 m-0 p-0">
                      <li>
                        <span className="main-color fw-500">
                          Excellent Quality:
                        </span>{" "}
                        We make sure to provide auto parts from the best
                        manufacturers to ensure durability and high performance.
                      </li>
                      <li>
                        <span className="main-color fw-500">Expertise:</span>{" "}
                        Our team of automotive experts are always ready to
                        provide personal advice and support.
                      </li>
                      <li>
                        <span className="main-color fw-500">
                          Customer Focus:
                        </span>{" "}
                        We focus on meeting your needs and providing a seamless
                        shopping experience and superior service.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed p-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <h4 className="fs-3 m-0 py-2 px-3 aboutHeading ab-1 position-relative">
                      Our Products and Services
                    </h4>
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body p-2">
                    <ul className="fs-5 p-0 m-0">
                      <h4 className="m-0 main-color">
                        We offer a wide range of advanced auto parts and tools,
                        including:
                      </h4>
                      <li>
                        <span className=" fw-500">Engine components</span>
                      </li>
                      <li>
                        <span className=" fw-500">Tires and wheels</span>
                      </li>
                      <li>
                        <span className=" fw-500">Brake systems</span>
                      </li>
                      <li>
                        <span className=" fw-500">
                          Accessories to upgrade your car
                        </span>
                      </li>
                      <li>
                        <span className=" fw-500">
                          Professional maintenance and repair services
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header">
                  <button
                    class="accordion-button collapsed p-2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <h4 className="fs-3 m-0 py-2 px-3 aboutHeading ab-2 position-relative">
                      Our vision
                    </h4>
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse "
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body fs-5 p-2">
                    We envision a future where vehicle maintenance and upgrading
                    is made easy, giving drivers the ability to get the best
                    performance from their vehicles.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
